import React from "react";
import { Card, CardBody, Col, Row, Badge } from "reactstrap";

const FinansIstatistikleri = ({ stats, user }) => {
  return (
    <Card className="shadow-sm border-0">
      <CardBody className="bg-primary-subtle rounded-top">
        <div className="d-flex">
          <div className="me-4">
            <i className="mdi mdi-shield-account text-primary h1" />
          </div>
          <div className="flex-grow-1">
            <div className="text-primary">
              <h5 className="text-primary">{user?.AD_SOYAD || "Yönetici"}</h5>
              <p className="mb-1">{user?.Mail_Adress}</p>
              <Badge color="primary">Sistem Yöneticisi</Badge>
            </div>
          </div>
        </div>
      </CardBody>
      
      <CardBody className="border-top">
        <Row>
          <Col sm="6">
            <div>
              <p className="text-muted mb-2">Sistemdeki Nakit</p>
              <h5 className="text-success">{stats.totalRevenue.toLocaleString('tr-TR')} €</h5>
            </div>
          </Col>
          <Col sm="6">
            <div className="text-sm-end mt-4 mt-sm-0">
              <p className="text-muted mb-2">Aylık Büyüme</p>
              <h5>
                + 1.250 €
                <Badge color="success" className="ms-2 align-bottom"><i className="mdi mdi-arrow-up"></i> 12%</Badge>
              </h5>
            </div>
          </Col>
        </Row>
      </CardBody>
      
      <CardBody className="border-top">
        <p className="text-muted mb-4">Hızlı Finansal İşlemler</p>
        <div className="text-center">
          <Row>
            <Col sm="4">
              <div>
                <div className="font-size-24 text-success mb-2"><i className="bx bx-send" /></div>
                <p className="text-muted mb-2">Sürücüye Öde</p>
              </div>
            </Col>
            <Col sm="4">
              <div>
                <div className="font-size-24 text-primary mb-2"><i className="bx bx-import" /></div>
                <p className="text-muted mb-2">Tahsilat Al</p>
              </div>
            </Col>
            <Col sm="4">
              <div>
                <div className="font-size-24 text-warning mb-2"><i className="bx bx-wallet" /></div>
                <p className="text-muted mb-2">Kasa Çıkışı</p>
              </div>
            </Col>
          </Row>
        </div>
      </CardBody>
    </Card>
  );
};

export default FinansIstatistikleri;